/**
 * @deprecated The two approval infos are now stored in separate documents
 */
export interface Approval {
  courseApproval: ApprovalInfo;
  curriculumApproval: ApprovalInfo;
}

export interface ApprovalInfo {
  status: ApprovalStatus;
  comments?: string;
}

export enum ApprovalStatus {
  Approved,
  Flag,
  Denied,
  NoReview,
}
